import { render, staticRenderFns } from "./CardMobileProfissional.vue?vue&type=template&id=51c08f68&scoped=true&"
var script = {}
import style0 from "./CardMobileProfissional.vue?vue&type=style&index=0&id=51c08f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c08f68",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c08f68')) {
      api.createRecord('51c08f68', component.options)
    } else {
      api.reload('51c08f68', component.options)
    }
    module.hot.accept("./CardMobileProfissional.vue?vue&type=template&id=51c08f68&scoped=true&", function () {
      api.rerender('51c08f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/mobile/CardMobileProfissional.vue"
export default component.exports